import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import { styled } from '@mui/material/styles';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem, treeItemClasses } from '@mui/x-tree-view/TreeItem';
import FolderIcon from '@mui/icons-material/Folder';
import Grid from "@mui/material/Grid";

const CustomTreeItem = styled(TreeItem)({
    [`& .${treeItemClasses.iconContainer}`]: {
        '& .close': {
            opacity: 0.3,
        },
    },
});

export default function CustomIcons() {
    return (
        <Box>
            <Card sx={{ height: '100%', }}>
                <CardContent>
                    <Typography
                        component="h2"
                        variant="subtitle2"
                        gutterBottom
                        sx={{ fontWeight: '600' }}
                    >
                        Explore your data
                    </Typography>
                    <Grid container spacing={1} >
                        <Grid size={3}>    <SimpleTreeView
                            defaultExpandedItems={['grid']}
                            slots={{
                                expandIcon: FolderIcon,
                                collapseIcon: IndeterminateCheckBoxIcon,
                                endIcon: FolderIcon,
                            }}
                        >
                            <CustomTreeItem itemId="grid" label="Data Grid">
                                <CustomTreeItem itemId="grid-community" label="@mui/x-data-grid" />
                                <CustomTreeItem itemId="grid-pro" label="@mui/x-data-grid-pro" />
                                <CustomTreeItem itemId="grid-premium" label="@mui/x-data-grid-premium" />
                            </CustomTreeItem>
                            <CustomTreeItem itemId="pickers" label="Date and Time Pickers">
                                <CustomTreeItem itemId="pickers-community" label="@mui/x-date-pickers" />
                                <CustomTreeItem itemId="pickers-pro" label="@mui/x-date-pickers-pro" />
                            </CustomTreeItem>
                            <CustomTreeItem itemId="charts" label="Charts">
                                <CustomTreeItem itemId="charts-community" label="@mui/x-charts" />
                            </CustomTreeItem>
                            <CustomTreeItem itemId="tree-view" label="Tree View">
                                <CustomTreeItem itemId="tree-view-community" label="@mui/x-tree-view" />
                            </CustomTreeItem>
                        </SimpleTreeView> </Grid>
                        <Grid size={9}>  </Grid>
                    </Grid>

                </CardContent>
            </Card>
        </Box>
    );
}
